let storeConfig = {
  logo: 'https://lacampa.s3.ap-southeast-2.amazonaws.com/assets/rocket%20pizza%208642567790_1700821198792.svg',
  logoPath:
    'https://assets.nextorder.co/assets/rocket%20pizza%208642567790_1700821198792.svg',
  storeId: 'KpJtwa0YJWZa8Q1pLZkl',
  restaurantId: 'QpMxA6KGhUQlxGRS9hZP',
  timeZone: 'Australia/Sydney',
  environment: 'production',
  release: 'x.x.x',
  cloudFunctionsUrl:
    'https://us-central1-next-order-prodenv.cloudfunctions.net',
  storeColorCode: '#1f8b05',
  publishableKey: 'pk_live_60LVIsMHVKRr9XuR6mWZtbLw00Yxn7gIg6',
  stores: [
    {
      logo: 'https://lacampa.s3.ap-southeast-2.amazonaws.com/assets/rocket%20pizza%208642567790_1700821198792.svg',
      storeId: '0seWiMWmswST5x8NDXLt',
      restaurantId: 'QpMxA6KGhUQlxGRS9hZP',
      baseUrl: '',
      baseUrls: ['https://rocketboy-pizza-potts-point.nextorder.com'],
      timeZone: 'Australia/Sydney',
      addressLocation: {
        lat: -33.8729073,
        long: 151.2224799,
      },
      name: 'Rocketboy Pizza',
      type: 'Pizza',
      address: '2/165 Victoria St, Potts Point',
      city: 'Sydney',
      state: 'New South Wales',
      stateIdentifier: 'NSW',
      country: 'Australia',
      countryCode: '+61',
      countryIdentifier: 'AU',
      currency: '$',
      currencyHtml: '&#36;',
      currencyCode: 'AUD',
      phoneNumberDisplay: '+61293577727',
      phoneNumber: '+61293577727',
      environment: 'production',
      release: 'x.x.x',
      cloudFunctionsUrl:
        'https://us-central1-next-order-prodenv.cloudfunctions.net',
      storeColorCode: '#e25a28',
      storeSecondColorCode: '#5e7462',
      publishableKey: 'pk_live_60LVIsMHVKRr9XuR6mWZtbLw00Yxn7gIg6',
      areaCode: '2011',
      area: 'Potts Point',
    },
    {
      logo: 'https://lacampa.s3.ap-southeast-2.amazonaws.com/assets/rocket%20pizza%208642567790_1700821198792.svg',
      storeId: '3I9AABXtmMn7o3h8VmKr',
      restaurantId: 'QpMxA6KGhUQlxGRS9hZP',
      baseUrl: '',
      baseUrls: ['https://rocketboy-pizza-randwick.nextorder.com'],
      timeZone: 'Australia/Sydney',
      addressLocation: {
        lat: -33.9118167,
        long: 151.2436012,
      },
      name: 'Rocketboy Pizza',
      type: 'Pizza',
      address: '103 Avoca St, Randwick',
      city: 'Sydney',
      state: 'New South Wales',
      stateIdentifier: 'NSW',
      country: 'Australia',
      countryCode: '+61',
      countryIdentifier: 'AU',
      currency: '$',
      currencyHtml: '&#36;',
      currencyCode: 'AUD',
      phoneNumberDisplay: '+61293265550',
      phoneNumber: '+61293265550',
      environment: 'production',
      release: 'x.x.x',
      cloudFunctionsUrl:
        'https://us-central1-next-order-prodenv.cloudfunctions.net',
      storeColorCode: '#e25a28',
      storeSecondColorCode: '#5e7462',
      publishableKey: 'pk_live_60LVIsMHVKRr9XuR6mWZtbLw00Yxn7gIg6',
      areaCode: '2031',
      area: 'Randwick',
    },
    {
      logo: 'https://lacampa.s3.ap-southeast-2.amazonaws.com/assets/rocket%20pizza%208642567790_1700821198792.svg',
      storeId: 'KpJtwa0YJWZa8Q1pLZkl',
      restaurantId: 'QpMxA6KGhUQlxGRS9hZP',
      baseUrl: '',
      baseUrls: ['https://rocketboy-pizza.nextorder.com'],
      timeZone: 'Australia/Sydney',
      addressLocation: {
        lat: -33.8965195,
        long: 151.15375,
      },
      name: 'Rocketboy Pizza',
      type: 'Pizza',
      address: '3/88-94 New Canterbury Rd, Petersham',
      city: 'Sydney',
      state: 'New South Wales',
      stateIdentifier: 'NSW',
      country: 'Australia',
      countryCode: '+61',
      countryIdentifier: 'AU',
      currency: '$',
      currencyHtml: '&#36;',
      currencyCode: 'AUD',
      phoneNumberDisplay: '+61295509988',
      phoneNumber: '+61295509988',
      environment: 'production',
      release: 'x.x.x',
      cloudFunctionsUrl:
        'https://us-central1-next-order-prodenv.cloudfunctions.net',
      storeColorCode: '#e25a28',
      storeSecondColorCode: '#5e7462',
      publishableKey: 'pk_live_60LVIsMHVKRr9XuR6mWZtbLw00Yxn7gIg6',
      areaCode: '2049',
      area: 'Petersham',
    },
    {
      logo: ' https://lacampa.s3.ap-southeast-2.amazonaws.com/assets/rocket%20pizza%208642567790_1700821198792.svg',
      storeId: 'WU4F5VytegHc6CS1FliF',
      restaurantId: 'QpMxA6KGhUQlxGRS9hZP',
      baseUrl: '',
      baseUrls: ['https://rocketboy-pizza-maroubra.nextorder.com'],
      timeZone: 'Australia/Sydney',
      addressLocation: {
        lat: -33.9389658,
        long: 151.2573218,
      },
      name: 'Rocketboy Pizza',
      type: 'Pizza',
      address: '323 Malabar Rd, Maroubra',
      city: 'Maroubra',
      state: 'New South Wales',
      stateIdentifier: 'NSW',
      country: 'Australia',
      countryCode: '+61',
      countryIdentifier: 'AU',
      currency: '$',
      currencyHtml: '&#36;',
      currencyCode: 'AUD',
      phoneNumberDisplay: '+61293444111',
      phoneNumber: '+61293444111',
      environment: 'production',
      release: 'x.x.x',
      cloudFunctionsUrl:
        'https://us-central1-next-order-prodenv.cloudfunctions.net',
      storeColorCode: '#e25a28',
      storeSecondColorCode: '#5e7462',
      publishableKey: 'pk_live_60LVIsMHVKRr9XuR6mWZtbLw00Yxn7gIg6',
      areaCode: '2035',
      area: 'Maroubra',
    },
    {
      logo: ' https://lacampa.s3.ap-southeast-2.amazonaws.com/assets/rocket%20pizza%208642567790_1700821198792.svg',
      storeId: 'ld43lp5IjJ9i6X1XsUZC',
      restaurantId: 'QpMxA6KGhUQlxGRS9hZP',
      baseUrl: '',
      baseUrls: ['https://rocketboy-pizza-newtown.nextorder.com'],
      timeZone: 'Australia/Sydney',
      addressLocation: {
        lat: -33.8925911,
        long: 151.1868643,
      },
      name: 'Rocketboy Pizza',
      type: 'Pizza',
      address: '30 King St, Newtown',
      city: 'Sydney',
      state: 'New South Wales',
      stateIdentifier: 'NSW',
      country: 'Australia',
      countryCode: '+61',
      countryIdentifier: 'AU',
      currency: '$',
      currencyHtml: '&#36;',
      currencyCode: 'AUD',
      phoneNumberDisplay: '+61295193330',
      phoneNumber: '+61295193330',
      environment: 'production',
      release: 'x.x.x',
      cloudFunctionsUrl:
        'https://us-central1-next-order-prodenv.cloudfunctions.net',
      storeColorCode: '#e25a28',
      storeSecondColorCode: '#5e7462',
      publishableKey: 'pk_live_60LVIsMHVKRr9XuR6mWZtbLw00Yxn7gIg6',
      areaCode: '2042',
      area: 'Newtown',
    },
  ],
};

export default storeConfig;
